export default {"src":"/_next/static/media/repl-disconnect.f136b432.gif","height":152,"width":328,"blurWidth":0,"blurHeight":0};